import apiClient from './apiClient';
import type {
    PostureInstruction,
    CreatePostureInstructionDto,
    UpdatePostureInstructionDto,
} from '../types/types';

const postureInstructionsService = {
    getAll: async (): Promise<PostureInstruction[]> => {
        const res = await apiClient.get<PostureInstruction[]>('/posture-instructions');
        return res.data;
    },

    getById: async (id: number): Promise<PostureInstruction> => {
        const res = await apiClient.get<PostureInstruction>(`/posture-instructions/${id}`);
        return res.data;
    },

    create: async (dto: CreatePostureInstructionDto): Promise<PostureInstruction> => {
        const res = await apiClient.post<PostureInstruction>('/posture-instructions', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdatePostureInstructionDto): Promise<PostureInstruction> => {
        const res = await apiClient.patch<PostureInstruction>(`/posture-instructions/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/posture-instructions/${id}`);
        return res.data;
    },
};

export default postureInstructionsService;
